import { Component, createElement } from "react";

const withGoogleMapsApi = apiKey => {
  return WrappedComponent =>
    class WithContentRect extends Component {
      state = {
        loading: false
      };
      onScriptLoad() {
        this.setState({ loading: false });
      }
      constructor(props) {
        super(props);
        this.state.loading = true;
        this.onScriptLoad = this.onScriptLoad.bind(this);
      }
      componentDidMount() {
        if (!window.google) {
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src = `https://maps.google.com/maps/api/js?key=${apiKey}&libraries=places`;
          script.id = "googleMaps";
          script.addEventListener("load", e => {
            this.onScriptLoad();
          });
          document.body.appendChild(script);
        } else {
          this.onScriptLoad();
        }
      }

      render() {
        return this.state.loading ? (
          <div>Loading...</div>
        ) : (
          createElement(WrappedComponent, {
            ...this.props,
            GoogleMaps: window.google.maps
          })
        );
      }
    };
};

export default withGoogleMapsApi;
